// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AV0e4RglVLinGQ4T0KRDDg\\=\\= {\n  border: 1px solid #ce0018;\n  background-color: #f97a7a;\n  color: #333;\n  padding: 10px 15px;\n  margin: 15px 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n", "",{"version":3,"sources":["webpack://src/components/error-alert.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB","sourcesContent":[".errorAlert {\n  border: 1px solid #ce0018;\n  background-color: #f97a7a;\n  color: #333;\n  padding: 10px 15px;\n  margin: 15px 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorAlert": "AV0e4RglVLinGQ4T0KRDDg=="
};
export default ___CSS_LOADER_EXPORT___;
